import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/helpers/api-helper';
import familyFestPickupAssignmentAPI from '@infrastructure/family-fest-pickup-assignment-api';
export const createFamilyFestPickupAssignmentAsync = createAsyncThunk('familyFestPickupAssignment/create', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.createFamilyFestPickupAssignment(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFamilyFestPickupAssignmentAsync = createAsyncThunk('familyFestPickupAssignment/update', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.updateFamilyFestPickupAssignment(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllFamilyFestPickupAssignmentsAsync = createAsyncThunk('familyFestPickupAssignment/getAll', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.getAllFamilyFestPickupAssignments(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAssignedFamilyFestAttendeesByPickupLocationIdAsync = createAsyncThunk('familyFestPickupAssignment/getAssignedAttendeesByPickupLocationId', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.getAssignedFamilyFestAttendeesByPickupLocationId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUnassignedFamilyFestAttendeesByPickupLocationIdAsync = createAsyncThunk('familyFestPickupAssignment/getUnassignedAttendeesByPickupLocationId', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.getUnassignedFamilyFestAttendeesByPickupLocationId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyFestAttendeesByPickupLocationIdAsync = createAsyncThunk('familyFestPickupAssignment/getAttendeesByPickupLocationId', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.getFamilyFestAttendeesByPickupLocationId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyFestPickupAssignmentByIdAsync = createAsyncThunk('familyFestPickupAssignment/getById', async (id, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.getFamilyFestPickupAssignmentById(id);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteFamilyFestPickupAssignmentAsync = createAsyncThunk('familyFestPickupAssignment/delete', async (id, { rejectWithValue }) => {
    try {
        await familyFestPickupAssignmentAPI.deleteFamilyFestPickupAssignment(id);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const unassignFamilyFestAttendeeFromRouteVehicleAsync = createAsyncThunk('familyFestPickupAssignment/unassignFromRouteVehicle', async (assignmentIds, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.unassignFamilyFestAttendeeFromRouteVehicle(assignmentIds);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const unassignFamilyFestAttendeeFromVehicleAsync = createAsyncThunk('familyFestPickupAssignment/unassignFromVehicle', async (attendeeIds, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.unassignFamilyFestAttendeeFromVehicle(attendeeIds);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const assignFamilyFestAttendeeToVehicleAsync = createAsyncThunk('familyFestPickupAssignment/assignToVehicle', async ({ attendeeIds, vehicleId }, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.assignFamilyFestAttendeeToVehicle(attendeeIds, vehicleId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getFamilyFestAttendeesByVehicleIdAsync = createAsyncThunk('familyFestPickupAssignment/getAttendeesByVehicleId', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.getFamilyFestAttendeesByVehicleId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getUnassignedFamilyFestAttendeesByEventIdAsync = createAsyncThunk('familyFestPickupAssignment/getUnassignedAttendeesByEventId', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.getUnassignedFamilyFestAttendeesByEventId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAssignedFamilyFestAttendeesByEventIdAsync = createAsyncThunk('familyFestPickupAssignment/getAssignedAttendeesByEventId', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.getAssignedFamilyFestAttendeesByEventId(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const reassignFamilyFestAttendeesToPickupLocationAsync = createAsyncThunk('familyFestPickupAssignment/reassignAttendeesToPickupLocation', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.reassignFamilyFestAttendeesToPickupLocation(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const autoAssignFamilyFestAttendeesToPickupLocationAsync = createAsyncThunk('familyFestPickupAssignment/autoAssignToPickupLocation', async (pickupLocationId, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.autoAssignFamilyFestAttendeesToPickupLocation(pickupLocationId);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateFamilyFestVehicleAttendeeCountAsync = createAsyncThunk('familyFestPickupAssignment/updateVehicleAttendeeCount', async (request, { rejectWithValue }) => {
    try {
        const response = await familyFestPickupAssignmentAPI.assignFamilyFestAttendeeCountToVehicle(request);
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
